import Button from '@app/components/button';
import SmallAdd from '@app/components/icons/small-add';
import { T } from '@app/components/translation';

import style from './add-product.module.scss';

type Props = {
  onClick: () => void;
  disabled?: boolean;
};

export const AddProductButton = ({ onClick, disabled = false }: Props) => (
  <Button
    data-testid="add-product"
    icon={<SmallAdd height="8px" />}
    disabled={disabled}
    onClick={onClick}
    customClass={style.AddProduct}
  >
    <T
      _str="Add product"
      _comment="Text for button to add a product action."
    />
  </Button>
);
